// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see IdentityConfirmTapEvent
 */
export var IdentityConfirmTap = function (_a) {
    var verificationType = _a.verificationType, source = _a.source;
    return ({
        name: "Identity Confirm Tap",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Confirm",
            verification_type: verificationType !== undefined && verificationType !== null ? verificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentityOpenViewEvent
 */
export var IdentityOpenView = function (_a) {
    var flowToken = _a.flowToken, screenType = _a.screenType, source = _a.source, isEntryPointBadged = _a.isEntryPointBadged;
    return ({
        name: "Identity Open View",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Open",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            screen_type: screenType !== undefined && screenType !== null ? screenType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_entry_point_badged: isEntryPointBadged !== undefined && isEntryPointBadged !== null ? isEntryPointBadged.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentityVerifyStartEvent
 */
export var IdentityVerifyStart = function (_a) {
    var verificationType = _a.verificationType, step = _a.step;
    return ({
        name: "Identity Verify Start",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Verify",
            verification_type: verificationType !== undefined && verificationType !== null ? verificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentityVerifyTapEvent
 */
export var IdentityVerifyTap = function (_a) {
    var verificationType = _a.verificationType, step = _a.step, diection = _a.diection;
    return ({
        name: "Identity Verify Tap",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Verify",
            verification_type: verificationType !== undefined && verificationType !== null ? verificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            diection: diection !== undefined && diection !== null ? diection.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentityVerifyShowEvent
 */
export var IdentityVerifyShow = function (_a) {
    var verificationType = _a.verificationType, step = _a.step;
    return ({
        name: "Identity Verify Show",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Verify",
            verification_type: verificationType !== undefined && verificationType !== null ? verificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentityVerifyCancelEvent
 */
export var IdentityVerifyCancel = function (_a) {
    var verificationType = _a.verificationType, step = _a.step;
    return ({
        name: "Identity Verify Cancel",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Verify",
            verification_type: verificationType !== undefined && verificationType !== null ? verificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentityProvideBirthdateRequirementResolutionEvent
 */
export var IdentityProvideBirthdateRequirementResolution = function (_a) {
    var resolution = _a.resolution;
    return ({
        name: "Identity Provide BirthdateRequirementResolution",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Provide",
            resolution: resolution !== undefined && resolution !== null ? resolution.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IdentitySnapshotUpdateEvent
 */
export var IdentitySnapshotUpdate = function (_a) {
    var version = _a.version, updatedAt = _a.updatedAt, hasVerifiedIdentity = _a.hasVerifiedIdentity, electronicIdvStatus = _a.electronicIdvStatus, documentIdvStatus = _a.documentIdvStatus, canAttemptElectronicIdvAt = _a.canAttemptElectronicIdvAt, reason = _a.reason, reasonString = _a.reasonString, lastVerifiedAt = _a.lastVerifiedAt, accountHolderToken = _a.accountHolderToken;
    return ({
        name: "Identity Snapshot Update",
        parameters: {
            cdf_entity: "Identity",
            cdf_action: "Snapshot",
            version: version !== undefined && version !== null ? version.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            updated_at: updatedAt !== undefined && updatedAt !== null ? updatedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_verified_identity: hasVerifiedIdentity !== undefined && hasVerifiedIdentity !== null ? hasVerifiedIdentity.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            electronic_idv_status: electronicIdvStatus !== undefined && electronicIdvStatus !== null ? electronicIdvStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            document_idv_status: documentIdvStatus !== undefined && documentIdvStatus !== null ? documentIdvStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            can_attempt_electronic_idv_at: canAttemptElectronicIdvAt !== undefined && canAttemptElectronicIdvAt !== null ? canAttemptElectronicIdvAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason_string: reasonString !== undefined && reasonString !== null ? reasonString.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            last_verified_at: lastVerifiedAt !== undefined && lastVerifiedAt !== null ? lastVerifiedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            account_holder_token: accountHolderToken !== undefined && accountHolderToken !== null ? accountHolderToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
